import { render } from "./TimeTableStudent.vue?vue&type=template&id=c8e32e68&scoped=true"
import script from "./TimeTableStudent.vue?vue&type=script&lang=js"
export * from "./TimeTableStudent.vue?vue&type=script&lang=js"

import "./TimeTableStudent.vue?vue&type=style&index=0&id=c8e32e68&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8e32e68"]])

export default __exports__